import { ColorInput as MantineColorInput, ColorInputProps as MantineColorInputProps } from "@mantine/core";
import styles from "./styles.module.css";

export type ColorInputProps = MantineColorInputProps;

function ColorInput(props: ColorInputProps) {
  return (
    <MantineColorInput
      classNames={{
        root: styles.root,
      }}
      {...props}
    />
  );
}

export default ColorInput;
